module.exports = __webpack_public_path__ + "img/23.e421ba2d.gif";